import { type MCPServerInfo } from '../../types';

const PlaywrightServer: MCPServerInfo = {
  serverId: 'PLAYWRIGHT',
  name: 'Playwright',
  slug: 'playwright',
  description: 'Playwright MCP Server',
  source: {
    sourceType: 'REPOSITORY',
    type: 'COMMUNITY',
    repositoryUrl: 'https://github.com/executeautomation/mcp-playwright',
    commitSha: '51b2725',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'NONE',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {
      chromeExecutablePath: {
        type: 'string',
        description: 'ChromeExecutablePath',
        sensitive: false
      }
    }
  },
  deprecated: true
};

export default PlaywrightServer;
